export const INITIALIZE = 'INITIALIZE';
export const CONNECT = 'CONNECT';
export const DISCONNECT = 'DISCONNECT';
export const GET_OPEN_STATE = 'GET_OPEN_STATE';
export const GET_VISIBLE_STATE = 'GET_VISIBLE_STATE';
export const GET_FULLSCREEN_STATE = 'GET_FULLSCREEN_STATE';
export const SHOW_CHAT = 'SHOW_CHAT';
export const HIDE_CHAT = 'HIDE_CHAT';
export const TOGGLE_CHAT = 'TOGGLE_CHAT';
export const OPEN_CHAT = 'OPEN_CHAT';
export const CLOSE_CHAT = 'CLOSE_CHAT';
export const TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
export const SET_FULLSCREEN = 'SET_FULLSCREEN';
export const SET_LARGECHATSIZE = 'SET_LARGECHATSIZE';
export const TOGGLE_INPUT_DISABLED = 'TOGGLE_INPUT_DISABLED';
export const ADD_NEW_USER_MESSAGE = 'ADD_NEW_USER_MESSAGE';
export const EMIT_NEW_USER_MESSAGE = 'EMIT_NEW_USER_MESSAGE';
export const NAVIGATE = 'NAVIGATE';
export const ADD_NEW_RESPONSE_MESSAGE = 'ADD_NEW_RESPONSE_MESSAGE';
export const ADD_CAROUSEL = 'ADD_CAROUSEL';
export const ADD_NEW_VIDEO_VIDREPLY = 'ADD_NEW_VIDEO_VIDREPLY';
export const ADD_NEW_IMAGE_IMGREPLY = 'ADD_NEW_IMAGE_IMGREPLY';
export const ADD_COMPONENT_MESSAGE = 'ADD_COMPONENT_MESSAGE';
export const ADD_BUTTONS = 'ADD_BUTTONS';
export const SET_BUTTONS = 'SET_BUTTONS';
export const INSERT_NEW_USER_MESSAGE = 'INSERT_NEW_USER_MESSAGE';
export const DROP_MESSAGES = 'DROP_MESSAGES';
export const PULL_SESSION = 'PULL_SESSION';
export const NEW_UNREAD_MESSAGE = 'NEW_UNREAD_MESSAGE';
export const TRIGGER_MESSAGE_DELAY = 'TRIGGER_MESSAGE_DELAY';
export const TRIGGER_TOOLTIP_SENT = 'TRIGGER_TOOLTIP_SENT';
export const SHOW_TOOLTIP = 'SHOW_TOOLTIP';
export const CLEAR_METADATA = 'CLEAR_METADATA';
export const SET_LINK_TARGET = 'SET_LINK_TARGET';
export const SET_USER_INPUT = 'SET_USER_INPUT';
export const SET_PAGECHANGE_CALLBACKS = 'SET_PAGECHANGE_CALLBACKS';
export const SET_DOM_HIGHLIGHT = 'SET_DOM_HIGHLIGHT';
export const SET_HINT_TEXT = 'SET_HINT_TEXT';
export const SET_OLD_URL = 'SET_OLD_URL';
export const EVAL_URL = 'EVAL_URL';
export const SET_CUSTOM_CSS = 'SET_CUSTOM_CSS';
export const APPLICATION_EVENT = 'APPLICATION_EVENT';
export const WIDGET_EVENT = 'WIDGET_EVENT';
export const SET_GREETINGS = 'SET_GREETINGS';
export const SET_GREETINGS_DELAY = 'SET_GREETINGS_DELAY';
export const SHOW_GREETING = 'SHOW_GREETING';
export const HIDE_GREETING = 'HIDE_GREETING';
export const HIDE_ALL_GREETINGS = 'HIDE_ALL_GREETINGS';
export const CONFIGURE_SOCKETURL = 'CONFIGURE_SOCKETURL';
export const CONFIGURE_HTTPBACKENDURL = 'CONFIGURE_HTTPBACKENDURL';
export const SET_USERINFOEXISTS = 'SET_USERINFOEXISTS';
export const SET_CUSTOMERID = 'SET_CUSTOMERID';
export const SET_USERID = 'SET_USERID';
export const SET_BROWSERLOCATION = 'SET_BROWSERLOCATION';
export const SET_AUTHTOKEN = 'SET_AUTHTOKEN';
export const SET_MESSAGE_FEEDBACK = 'SET_MESSAGE_FEEDBACK';
export const SET_ANALYTICS_SERVICE_URL = 'SET_ANALYTICS_SERVICE_URL';
export const SET_SESSIONID = 'SET_SESSIONID';
